/* External Deps */
import { FC, ReactElement } from "react";
import { Outlet } from "react-router-dom";

const Documents: FC = (): ReactElement => {
  return <Outlet />;
};

export default Documents;